import axios from "axios";
import { defineStore } from "pinia";

const URL = process.env.VUE_APP_BASE_URL + "/merchants";
const API_KEY = process.env.VUE_APP_BACKEND_API_KEY as string;
const config = { headers: { "x-api-key": API_KEY } };

export const useMerchantStore = defineStore("merchant", {
  actions: {
    async validateMerchant(merchantId: string) {
      try {
        return await axios.get(URL + "/" + merchantId, config);
      } catch (error) {
        console.error("Error validating merchant:", error);
        throw error;
      }
    },
  },
});
